import { getQRPlateData } from '../../../data/repositories/businessRepository.js';

export const fetchQRPlateData = (businessId) => getQRPlateData(businessId);
